import { useState, useEffect, useRef, useCallback } from 'react';
import { authenticatedRequest } from '../utils/api';

export const useInvestData = () => {
  const [data, setData] = useState([]);
  const [forexData, setForexData] = useState({});
  const [loading, setLoading] = useState(false);
  const [initialized, setInitialized] = useState(false);
  
  // 防重复请求
  const lastRequestRef = useRef('');
  const abortControllerRef = useRef(null);
  const initialLoadRef = useRef(false);

  // 数据获取函数
  const fetchData = useCallback(async (currentChartType, currentRange, currentFreecode) => {
    if (!currentChartType || !currentRange) return;

    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    abortControllerRef.current = new AbortController();
    
    const requestKey = `${currentChartType}-${currentRange}${currentFreecode ? `-${currentFreecode}` : ''}`;
    
    if (lastRequestRef.current === requestKey) {
      return;
    }
    
    lastRequestRef.current = requestKey;
    
    let url = `/metrics/${currentChartType}?days=${currentRange}`;
    if (currentFreecode && initialized) { // 只有初始化后才使用 freecode
      url += `&freecode=${currentFreecode}`;
    }
    
    setLoading(true);
    
    try {
      let res = null;
      
      if (!initialized){
        res = await authenticatedRequest(url);
      }else{
        res = await authenticatedRequest(url, {
          signal: abortControllerRef.current.signal
        });
      }
      
      if (!res) {
        // authenticatedRequest 已处理401错误并跳转登录
        return;
      }
      
      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }
      
      const json = await res.json();
      
      // 添加调试日志
    //   console.log('Backend response for days:', currentRange, 'data:', json);
      
      // 检查返回结果是否为8964
      if (json === 8964) {
        alert('五年以上數據僅對VIP用戶開放');
        return;
      }
      
      if (currentChartType === "forex") {
        setForexData(json);
        setData([]);
      } else {
        setData(json);
        setForexData({});
      }
      
      // 首次加载完成后标记为已初始化
      if (!initialLoadRef.current) {
        initialLoadRef.current = true;
        setInitialized(true);
      }
      
    } catch (err) {
      if (err.name !== 'AbortError') {
        console.error("獲取數據失敗:", err);
      }
    } finally {
      setLoading(false);
    }
  }, [initialized]);

  // 清理函数
  useEffect(() => {
    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, []);

  return {
    data,
    forexData,
    loading,
    initialized,
    fetchData
  };
};